import { InAppBrowser } from '@/src/common/components/InAppBrowser'
import { routerBack } from '@/src/common/utils/routerBack'
import { useLocalSearchParams } from 'expo-router'

type SearchParams = Record<string, string | string[]>

interface MesaInAppBrowserParams extends SearchParams {
  title: string
  uri: string
}

export default function MesaInAppBrowser() {
  const { title, uri } = useLocalSearchParams<MesaInAppBrowserParams>()

  if (!title || !uri) {
    return null
  }

  return (
    <InAppBrowser
      title={title}
      uri={uri}
      onBackPress={() => {
        void routerBack()
      }}
    />
  )
}
